import { render } from "./ResPrecoConfortLumOrientations.vue?vue&type=template&id=1dbd0bed"
const script = {}

import exportComponent from "F:\\PROMODUL\\Projets\\APP.LUMIERE+\\code\\lumiere_plus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__